export enum ShedBaseType {
  None = 'none',
  GalvanizedSteel = 'galvanized-steel',
  Skids = 'skids',
  WallExtension = 'wall-extension',
}
